import React, { Component } from 'react';
import { APP_URL_API } from '../../../../setup/configs'
import Modal from '../../../../ui/modal/Modal';
import axios from 'axios';

export default class ResetPassword extends Component {
	    constructor(props) {
        super(props)

        this.state = {
          showModal: false,
          username: '',
          password: ''
        }
    };
	onToggleModal = () => {
        if(this.state.showModal) {
            this.setState({
                showModal: false
            });
        } else {
            this.setState({
                showModal: true
            })
        }
    }
    componentDidMount = () => {
        if(this.props.showResetPassword) this.onResetPassword();
    }
    onCreateEmail = () => {
    	const body = "By-, Land- og Kirkeministeriet har nulstillet jeres kodeord til Trossamfundsregistret på http://www.km.dk/andre-trossamfund/" + escape('\r\n\r\n') + "Brugernavn: " + this.state.username + escape('\r\n\r\n') + "Nyt kodeord: " + this.state.password + escape('\r\n\r\n') + "Med venlig hilsen" + escape('\r\n\r\n') + "By-, Land- og Kirkeministeriet";
    	window.location.href = 'mailto:?subject=Nulstilling af kodeord på Trossamfundsregistret&body='+body;
    }
    onResetPassword = () => {
    	const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'organizations/' + this.props.organizationId + '/user/resetPassword';

        const data = {};
        data._method = "patch";

        this.serverRequest =
            axios
                .post(url, data, {headers: config})
                .then(function(response) {
                    this.setState({
                    	username: response.data.data.username,
                    	password: response.data.data.password
                    }, this.onToggleModal())
                }.bind(this))
    }
    render() {
		return(
			<div>
				<button type="button" className="button" onClick={() => { if (window.confirm('Er du sikker på at du vil nulstille kodeordet?')) this.onResetPassword()}}>Nulstil kodeord</button>
				<Modal visible={this.state.showModal}>
					<h4>Nyt kodeord</h4>
					<div style={{marginTop: '1em'}}></div>
					<table><tbody><tr><td>Brugernavn:</td><td>{this.state.username}</td></tr><tr><td>Adgangskode:</td><td>{this.state.password}</td></tr></tbody></table>
					<div style={{marginTop: '1em'}}>
                            <button type="button" className="button" onClick={() => this.onToggleModal()}>Luk</button>
                            <button type="button" className="button" onClick={this.onCreateEmail}>Opret Email</button>
                        </div>
				</Modal>
			</div>)
	}
}


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/ResetPassword.js